import {Link} from "react-router-dom";

function BlogCard(props) {
    return (
        <>
            <Link to={props?.link? props?.link : '#'} className="blogPgCard">
                <figure data-aos='fade-in' data-aos-delay='50'>
                    <img src={process.env.PUBLIC_URL + '/images/' + props?.imgPath} alt=""/>
                </figure>
                <h4 data-aos='fade-up'>Unlock the Power of Knowledge</h4>
                <p data-aos='fade-up' data-aos-delay='100'>
                    In the ever-evolving landscape of technology and DevOps, staying informed is not
                    just an advantage; it's a necessity. Our blog serves as a treasure trove of
                    information, offering you in-depth articles, expert opinions, and practical advice
                    that can elevate your skills and decision-making.
                </p>
            </Link>
        </>
    )
}

export default BlogCard